import React from "react";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { Form, FormGroup, Label } from "reactstrap";
import ActionButton from "shared/components/ActionButton/index";
import AlertSuccess from "shared/components/Alerts/alert_success";
import Input from "shared/components/Input/index";
import simpleReactValidator from "simple-react-validator";
import { userLogin, userLogout } from "../../actions/actions";
import icon from "./asepsis-logo.svg";
import "./style.css";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      login_fail: false,
      blocking: false,
      visible: true,
    };
    this.validator = new simpleReactValidator();
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
  }
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(userLogout());
  }

  onDismiss() {
    this.setState({ visible: false });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.login_user_data != this.props.login_user_data) {
      if (this.props.login_user_data.success == true) {
        this.setState({
          blocking: false,
          visible: true,
        });
        browserHistory.push("/dashboard");
        window.location.reload();
      } else {
        this.setState({
          login_fail: true,
          blocking: false,
          visible: true,
        });
      }
    }
  }

  onSubmitClick() {
    var that = this;
    if (that.validator.fieldValid("email") && that.validator.fieldValid("password")) {
      var post = {
        email: that.state.email,
        password: that.state.password,
      };
      this.setState({
        blocking: !this.state.blocking,
      });
      that.props.dispatch(userLogin(post));
    } else {
      that.validator.showMessages();
      that.forceUpdate();
    }
  }
  onChangePassword(e) {
    var getpassword = e.target.value;
    if (getpassword != "") {
      this.setState({
        password: getpassword,
      });
    }
  }

  onChangeEmail(e) {
    var getemail = e.target.value;
    if (getemail != null) {
      this.setState({
        email: getemail,
      });
    }
  }

  render() {
    const { login_user_data } = this.props;

    return (
      <div className="login-page">
        <BlockUi tag="div" blocking={this.state.blocking} className="login-block-ui">
          <div className="login-container">
            <div className="login-card">
              <div className="login-logo">
                <img src={icon} alt="ASEPSIS - Aged Care Standard" />
              </div>

              {login_user_data != "" ? (
                login_user_data.success == false ? (
                  <AlertSuccess visible={this.state.visible} onDismiss={this.onDismiss} color={"danger"} alertText={login_user_data.message} />
                ) : (
                  ""
                )
              ) : (
                ""
              )}

              <Form>
                <FormGroup>
                  <Label>USER NAME</Label>
                  <Input type={"email"} id={"email"} name="email" value={this.state.email} placeholder={"demo@example.com"} onChange={this.onChangeEmail} maxLength={50} />
                  <span className="error-text">
                    {this.validator.message("email", this.state.email, "required", false, { default: "This field is required.", email: "Please enter valid email" })}
                  </span>
                </FormGroup>

                <FormGroup>
                  <Label>PASSWORD</Label>
                  <Input type={"password"} id={"password"} name="password" value={this.state.password} placeholder={"••••••••••"} onChange={this.onChangePassword} maxLength={20} />
                  <span className="error-text">{this.validator.message("password", this.state.password, "required", false, { default: "This field is required." })}</span>
                </FormGroup>

                <FormGroup className="login-button-group">
                  <ActionButton color={"primary"} className="btn-login-submit" size={"md"} button_name={"Sign In"} button_click={this.onSubmitClick} />
                </FormGroup>
              </Form>
            </div>
          </div>
        </BlockUi>
      </div>
    );
  }
}
function mapStateToProps(state) {
  const { postsBySubreddit } = state;
  const { login_user_data: login_user_data } = postsBySubreddit;
  return { login_user_data };
}

const AppContainer = connect(mapStateToProps)(Login);

export default AppContainer;



// WEBPACK FOOTER //
// ./src/shared/containers/Login/index.js